export default __webpack_public_path__ + "static/Astronaut-90a13a776c5b539ddf78f6311a1ce656.svg";